import React from 'react';
import { NavLink } from 'react-router-dom';

var img1 = require('./../../images/left-men.png');
var img2 = require('./../../images/background/bg-4.png');
var img3 = require('./../../images/background/bg-site.png');
var img4 = require('./../../images/mission.jpg');

class OurMission extends React.Component {
    render() {
        return (
            <>
                <div className="section-full mobile-page-padding mission-outer-section  p-t80 p-b30 bg-gray bg-no-repeat bg-right-center" style={{ backgroundImage: 'url(' + img1 + '), url(' + img2 + ')' }}>
                    <div className="section-content">
                        <div className="container">
                            {/* TITLE START */}
                            <div className="section-head">
                                <div className="mt-separator-outer separator-center">
                                    <div className="mt-separator">
                                        <h2 className="text-uppercase sep-line-one "><span className="font-weight-300 text-primary">Our</span> Mission</h2>
                                    </div>
                                </div>
                            </div>
                            {/* TITLE END */}
                            <div className="row">
                                    <div className="col-md-4 col-sm-6">
                                        <div className="mission-left bg-white m-b30 p-a30 bg-no-repeat bg-bottom-left" style={{ backgroundImage: 'url(' + img3 + ')' }}>
                                            <h3 className="m-t0"><span className="font-weight-100">Site Coverage</span><br /> Areas We Secure</h3>
                                            <p>From design to deployment, we bring life-saving fire safety solutions across industrial, residential, and commercial spaces.</p>
                                            <ul className="list-angle-right anchor-line">
                                                <li><NavLink to={"/services"}>Fire Alarm Installation</NavLink></li>
                                                <li><NavLink to={"/services"}>Sprinkler System Setup</NavLink></li>
                                                <li><NavLink to={"/services"}>Smoke & Heat Detection</NavLink></li>
                                                <li><NavLink to={"/services"}>Fire Extinguisher Supply & Service</NavLink></li>
                                                <li><NavLink to={"/services"}>AMC & Safety Audits</NavLink></li>
                                            </ul>
                                            <div className="text-right">
                                                <NavLink to="/about" className="site-button-link" data-hover="Read More">Read More <i className="fa fa-angle-right arrow-animation" /></NavLink>
                                            </div>
                                        </div>
                                    </div>

                                <div className="col-md-4 col-sm-6">
                                    <div className="mission-mid bg-no-repeat bg-cover m-b30" style={{ backgroundImage: 'url(' + img4 + ')' }} />
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="hilite-title text-left p-l50 text-uppercase text-pop-up-top">
                        <strong>Mission</strong>
                    </div>
                </div>
            </>
        );
    }
};

export default OurMission;